import styled from '@emotion/styled';
import { ListItem, ListItemAvatar, ListItemText } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';

import theme from '../../../../theme';
import DummyContent from '../../primitive/DummyContent';
import DummyRectangle from '../../primitive/DummyRectangle';

type Props = ClassAttributes<HTMLElement> & {
  className?: string;
};

const DummyItem = ({ className }: Props) => (
  <Root className={className} button>
    <ListItemText>
      <Title />
      <Description />
    </ListItemText>
    <ListItemAvatar>
      <Thumbnail />
    </ListItemAvatar>
  </Root>
);

const Root = styled(ListItem)({
  width: '100%',
  backgroundColor: theme.palette.grey[300],
});

const Thumbnail = styled(DummyRectangle)({
  width: 160,
  height: 160,
});

const Title = styled(DummyContent)({
  width: 300,
  color: theme.palette.grey[100],
});

const Description = styled(DummyContent)({
  color: theme.palette.grey[100],
});

export default DummyItem;
